import { Button, Form } from "react-bootstrap"
import useCallApi from "../../hooks/useCallApi"
import DatePicker from 'react-datepicker'
import callAPI from "../../helpers/callAPI"
import { useContext, useEffect, useState } from "react"
import { SystemMessageContext } from "../../context/SystemMessageContext"
import moment from "moment"
import Loading from "../../templates/UI/Loading/Loading"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AdminDropdown from "../../templates/Layout/Toolbar/AdminDropdown/AdminDropdown"
import AdminPicker from "../AdminPicker/AdminPicker"

const EMAIL_SUBJECT_MAX_LENGTH = 100

const DocuSignInsertionOrderContent = ({ offerId, closeModal }) => {
    const templateId = '69d6f7b3-de3f-42d3-9dba-5179607fcb04'//'dfda10b0-1b91-4522-9a15-88e9fe4ff7cf'
    const [spinner, setSpinner] = useState(false)
    const [emailSubject, setEmailSubject] = useState('')
    
    const { showSystemMessage } = useContext(SystemMessageContext)
    useEffect(() => {
        if (emailSubject.length >= EMAIL_SUBJECT_MAX_LENGTH) {
            showSystemMessage('error', 'Email subject must be less than 100 characters. Please shorten the campaign name in the campaign settings page before continuing.')
        }
    }, [emailSubject])

    const { dataLoaded, data } = useCallApi(`docusign/prefillData/insertionOrder/${offerId}`, 'GET', {}, [])



    const getCampaignReversalCriteria = (letter) => {
        let criteria = ''

        if (letter == 'U') {
            criteria = 'Unknown'
        } else if (letter == 'N') {
            criteria = 'None Allowed'
        } else if (letter == 'F') {
            criteria = 'Fraud Only'
        } else if (letter == 'I') {
            criteria = 'Fraud/Invalid Leads'
        } else {
            criteria = `Other (${letter})`
        }
        return criteria
    }

    // Check if we're in development environment
    const isDev = process.env.NODE_ENV === 'development'

    const [tabs, setTabs] = useState([])
    useEffect(() => {
        const paymentTerms = (number) => {
            switch (number) {
                case 0:
                    return 'Unknown';
                case -1:
                    return 'Pre-payment';
                case 1:
                    return 'Net 1';
                case 7:
                    return 'Net 7';
                case 15:
                    return 'Net 15';
                case 30:
                    return 'Net 30';
                case 45:
                    return 'Net 45';
                case 60:
                    return 'Net 60';
                default:
                    return 'Unknown';
            }
        }
        if (dataLoaded) {
            const defaultSubject = `${data.data.mdData.name} - ${data.data.oData.name} - MaxBounty IO`
            setEmailSubject(defaultSubject)
            const tempTabs = [
                {
                    "tabLabel": "signee_name",
                    "tabType": "textTabs",
                    "value": data.data.mdData.contact,
                    "required": true,
                    "name": "Recipient Name"
                },
                {
                    "tabLabel": "signee_email",
                    "tabType": "textTabs",
                    "value": isDev ? "travis.anderson@mrge.com" : data.data.mData.e_mail,
                    "required": true,
                    "name": "Recipient Email"
                },
                {
                    "tabLabel": "mb_id",
                    "value": data.data.admin.id,
                    "tabType": "textTabs",
                    "required": true,
                    "name": "MaxBounty Signer"
                },
                {
                    "tabLabel": "Date Signed 2e3af84a-4756-4ae0-822b-4aaad2c352fa",
                    "tabType": "dateSignedTabs",
                    "value": "",
                    'required': false,
                    "name": "Date Signed"
                },
                {
                    "tabLabel": "Signature e55b1de4-bf61-4232-9a14-95ddca2811de",
                    "tabType": "signHereTabs",
                    "value": "",
                    'required': false,
                    "name": "Signature"
                },
                {
                    "tabLabel": "advertiser_signer_title",
                    "tabType": "textTabs",
                    "value": "",
                    'required': false,
                    "name": "Advertiser Signer Title"
                },
                {
                    "tabLabel": "advertiser_signer_name",
                    "tabType": "textTabs",
                    "value": "",
                    'required': false,
                    "name": "Advertiser Signer Name"
                },
                {
                    "tabLabel": "20_traffic_incentive",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.allow_incentive_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Incentive"
                },
                {
                    "tabLabel": "13_traffic_display",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.site_traffic_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Display"
                },
                {
                    "tabLabel": "16_traffic_search",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.search_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Search"
                },
                {
                    "tabLabel": "14_traffic_social",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.social_media_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Social"
                },
                {
                    "tabLabel": "17_traffic_mobile",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.mobile_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Mobile"
                },
                {
                    "tabLabel": "15_traffic_email",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.allow_solo_emails_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Email"
                },
                {
                    "tabLabel": "18_traffic_native",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.native_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Native"
                },
                {
                    "tabLabel": "21_traffic_brand_bidding",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.brand_bid_allow_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Brand Bidding"
                },
                {
                    "tabLabel": "19_traffic_contextual",
                    "tabType": "checkboxTabs",
                    "value": data.data.oData.contextual_flag === 'Y' ? 'true' : 'false',
                    'required': false,
                    "name": "Traffic Contextual"
                },
                {
                    "tabLabel": "Date Signed 7de1330f-637e-4e22-b3e7-09aa17d4286f",
                    "tabType": "dateSignedTabs",
                    "value": "",
                    'required': false,
                    "name": "Date Signed"
                },
                {
                    "tabLabel": "Signature 56dd9082-a78d-494d-90dd-a4b003768e1b",
                    "tabType": "signHereTabs",
                    "value": "",
                    'required': false,
                    "name": "Signature"
                },
                {
                    "tabLabel": "tabGroups",
                    "tabType": "tabGroups",
                    "value": "",
                    'required': false,
                    "name": "Tab Groups"
                },
                {
                    "tabLabel": "1_date_sent",
                    "tabType": "textTabs",
                    "value": moment().format('MM-DD-YYYY'),
                    'required': true,
                    "name": "Date Sent"
                },
                {
                    "tabLabel": "22_other_restrictions",
                    "tabType": "textTabs",
                    "value": data.data.oData.search_restrictions || '',
                    'required': false,
                    "name": "Other Restrictions"
                },
                {
                    "tabLabel": "23_changes_termination",
                    "tabType": "textTabs",
                    "value": "Advertiser can change the above items or terminate this Insertion Order with 2 business days' written notice.",
                    'required': false,
                    "name": "Changes Termination"
                },
                {
                    "tabLabel": "26_address",
                    "tabType": "textTabs",
                    "value": (data.data.mdData.street_address_1 || '') + ' ' + (data.data.mdData.street_address_2 || ''),
                    'required': true,
                    "name": "Address"
                },
                {
                    "tabLabel": "28_state",
                    "tabType": "textTabs",
                    "value": data.data.mdData.state || '',
                    'required': true,
                    "name": "State"
                },
                {
                    "tabLabel": "25_payment_terms",
                    "tabType": "textTabs",
                    "value": paymentTerms(data.data.miiData.payment_terms || ''),
                    'required': true,
                    "name": "Payment Terms"
                },
                {
                    "tabLabel": "27_city",
                    "tabType": "textTabs",
                    "value": data.data.mdData.city || '',
                    'required': true,
                    "name": "City"
                },
                {
                    "tabLabel": "29_zipcode",
                    "tabType": "textTabs",
                    "value": data.data.mdData.zip_code || '',
                    'required': true,
                    "name": "Zip Code"
                },
                {
                    "tabLabel": "30_execution_date",
                    "tabType": "textTabs",
                    "value": data.data.mData.agreement_sign_date ? moment(data.data.mData.agreement_sign_date).utc().format('MM-DD-YYYY') : '',
                    'required': true,
                    "name": "Execution Date"
                },
                {
                    "tabLabel": "4_advertiser_contact",
                    "tabType": "textTabs",
                    "value": data.data.mdData.contact,
                    'required': true,
                    "name": "Contact Name"
                },
                {
                    "tabLabel": "6_advertiser_email",
                    "tabType": "textTabs",
                    "value": isDev ? "travis.anderson@mrge.com" : data.data.mData.e_mail,
                    'required': true,
                    "name": "Email"
                },
                {
                    "tabLabel": "3_advertiser_phone",
                    "tabType": "textTabs",
                    "value": data.data.mdData.phone,
                    'required': false,
                    "name": "Phone"
                },
                {
                    "tabLabel": "5_advertiser_mobile",
                    "tabType": "textTabs",
                    "value": data.data.mdData.mobile_phone,
                    'required': false,
                    "name": "Mobile"
                },
                {
                    "tabLabel": "7_advertiser_im_handle",
                    "tabType": "textTabs",
                    "value": data.data.mdData.im_id,
                    'required': false,
                    "name": "IM Handle"
                },
                {
                    "tabLabel": "8_campaign_name",
                    "tabType": "textTabs",
                    "value": data.data.oData.name,
                    'required': true,
                    "name": "Campaign Name"
                },
                {
                    "tabLabel": "9_price_per_action",
                    "tabType": "textTabs",
                    "value": data.data.ocrData.find(rate => rate.default_flag === 'Y')?.networkRateText || '',
                    'required': true,
                    "name": "Price Per Action"
                },
                {
                    "tabLabel": "11_reversal_criteria",
                    "tabType": "textTabs",
                    "value": getCampaignReversalCriteria(data.data.oData.reversal_criteria),
                    'required': true,
                    "name": "Reversal Criteria"
                },
                {
                    "tabLabel": "12_supported_countries",
                    "tabType": "textTabs",
                    "value": data.data.oData.ip_filtering_flag === 'Y' ? (data.data.oData.allowedCountries.length <= 3 ? data.data.oData.allowedCountries.map(country => country.country_name).join(', ') : 'See Appendix A') : '',
                    'required': false,
                    "name": "Supported Countries"
                },
                {
                    "tabLabel": "10_definition_of_action",
                    "tabType": "textTabs",
                    "value": data.data.ocrData.find(rate => rate.default_flag === 'Y')?.description || '',
                    'required': true,
                    "name": "Definition of Action"
                },
                {
                    "tabLabel": "maxbounty_signer_name",
                    "tabType": "textTabs",
                    "value": "",
                    'required': false,
                    "name": "MaxBounty Signer Name"
                },
                {
                    "tabLabel": "2_advertiser_name",
                    "tabType": "textTabs",
                    "value": data.data.mdData.name,
                    'required': true,
                    "name": "Advertiser Name"
                },
                {
                    "tabLabel": "appendix_countries",
                    "tabType": "textTabs",
                    "value": data.data.oData.ip_filtering_flag === 'Y' ? (data.data.oData.allowedCountries.length > 3 ? `Appendix A: ${data.data.oData.allowedCountries.map(country => country.country_name).join(', ')}` : '') : '',
                    'required': false,
                    "name": "Appendix Countries"
                },
                {
                    "tabLabel": "31_appendix",
                    "tabType": "textTabs",
                    "value": '',
                    'required': false,
                    "name": "Appendix"
                },
                {
                    "tabLabel": "maxbounty_signer_title",
                    "tabType": "textTabs",
                    "value": "",
                    'required': false,
                    "name": "MaxBounty Signer Title"
                }
            ]
            setTabs(tempTabs)
        }
    }, [dataLoaded, isDev])

    const submit = async () => {
        if (!emailSubject.trim()) {
            return showSystemMessage('error', 'Email subject is required');
        }
        if (emailSubject.length >= EMAIL_SUBJECT_MAX_LENGTH) {
            return showSystemMessage('error', `Email subject must be less than ${EMAIL_SUBJECT_MAX_LENGTH} characters`);
        }
        //validate tabs
        const requiredTabs = tabs.filter(tab => tab.required && !tab.value)
        if (requiredTabs.length > 0) {
            //use the name property instead of tabLabel for more readable error messages
            return showSystemMessage('error', `${requiredTabs[0].name} is required`);
        }

        setSpinner(true)
        const subject = emailSubject.trim()
        //deep copy tabs to avoid mutating state directly
        let tabsToSend = JSON.parse(JSON.stringify(tabs))
        //combine the two appendix tabs into one with an empty line between them
        const appendixCountriesValue = tabsToSend.find(tab => tab.tabLabel === 'appendix_countries').value;
        const appendixValue = tabsToSend.find(tab => tab.tabLabel === '31_appendix').value;

        // Only add empty line if both have content
        const combinedValue = appendixCountriesValue && appendixValue
            ? `${appendixCountriesValue}\n\n${appendixValue}`
            : `${appendixCountriesValue}${appendixValue}`;

        tabsToSend[tabsToSend.findIndex(tab => tab.tabLabel === '31_appendix')].value = combinedValue;

        //we send the offerId here separatly so we can put it in a custom field in the envelope. used for locating where to store the envelope id in offers db later.
        const result = await callAPI(`docusign/sendEnvelope/${templateId}`, 'POST', { tabs: tabsToSend, subject, offerId: offerId }, false);
        if (!result.success) {
            setSpinner(false);
            return showSystemMessage('error', 'Failed to send document');
        }
        showSystemMessage('success', 'Document sent successfully');
        closeModal();
    }

    return (
        <>
            {(dataLoaded) ?
                (
                    <>
                        <p1 className='text-secondary'>* Please note that any changes made on this page will only affect the contract and will not be changed in our system</p1>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2 mt-3">
                            <span>Email Subject *</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={emailSubject}
                                    isInvalid={emailSubject.length > EMAIL_SUBJECT_MAX_LENGTH}
                                    onChange={(e) => setEmailSubject(e.target.value)}
                                />
                                <div className="d-flex justify-content-end mt-1">
                                    <span className={emailSubject.length > EMAIL_SUBJECT_MAX_LENGTH-1 ? 'text-danger' : 'text-secondary'}>
                                        {emailSubject.length} / {EMAIL_SUBJECT_MAX_LENGTH}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === 'signee_name')?.name}{tabs.find(tab => tab.tabLabel === 'signee_name')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === 'signee_name')?.value || ''}
                                    onChange={(e) => {

                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === 'signee_name' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }
                                    }
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === 'signee_email')?.name}{tabs.find(tab => tab.tabLabel === 'signee_email')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="email"
                                    value={tabs.find(tab => tab.tabLabel === 'signee_email')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === 'signee_email' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }
                                    }
                                />
                                {isDev && (
                                    <div className="alert alert-warning py-2 px-3 mt-2 mb-0 small" role="alert">
                                        Warning: Docusign sends this email, not us! Whatever email is here will receive an IO contract from Docusign even if you are in the dev environment. This warning is only visible in the dev environment.
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === 'mb_id')?.name}{tabs.find(tab => tab.tabLabel === 'mb_id')?.required && ' *'}</span>
                            <div className="w-75">
                                <AdminPicker
                                    adminId={tabs.find(tab => tab.tabLabel === 'mb_id')?.value || ''}
                                    setAdminId={(adminId) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === 'mb_id' ? { ...t, value: adminId } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>


                        <hr />
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '1_date_sent')?.name}{tabs.find(tab => tab.tabLabel === '1_date_sent')?.required && ' *'}</span>
                            <div className="w-75">
                                <DatePicker
                                    placeholderText="Scheduled Date"
                                    className="form-control form-control"
                                    selected={tabs.find(tab => tab.tabLabel === '1_date_sent')?.value ? moment(tabs.find(tab => tab.tabLabel === '1_date_sent').value, 'MM-DD-YYYY').toDate() : null}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '1_date_sent' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }
                                    }
                                    dateFormat="MM-dd-yyyy"
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '2_advertiser_name')?.name}{tabs.find(tab => tab.tabLabel === '2_advertiser_name')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '2_advertiser_name')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '2_advertiser_name' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '4_advertiser_contact')?.name}{tabs.find(tab => tab.tabLabel === '4_advertiser_contact')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '4_advertiser_contact')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '4_advertiser_contact' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '3_advertiser_phone')?.name}{tabs.find(tab => tab.tabLabel === '3_advertiser_phone')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '3_advertiser_phone')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '3_advertiser_phone' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '5_advertiser_mobile')?.name}{tabs.find(tab => tab.tabLabel === '5_advertiser_mobile')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '5_advertiser_mobile')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '5_advertiser_mobile' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '6_advertiser_email')?.name}{tabs.find(tab => tab.tabLabel === '6_advertiser_email')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="email"
                                    value={tabs.find(tab => tab.tabLabel === '6_advertiser_email')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '6_advertiser_email' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '7_advertiser_im_handle')?.name}{tabs.find(tab => tab.tabLabel === '7_advertiser_im_handle')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '7_advertiser_im_handle')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '7_advertiser_im_handle' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>

                        <hr />

                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '8_campaign_name')?.name}{tabs.find(tab => tab.tabLabel === '8_campaign_name')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '8_campaign_name')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '8_campaign_name' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '9_price_per_action')?.name}{tabs.find(tab => tab.tabLabel === '9_price_per_action')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '9_price_per_action')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '9_price_per_action' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '10_definition_of_action')?.name}{tabs.find(tab => tab.tabLabel === '10_definition_of_action')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '10_definition_of_action')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '10_definition_of_action' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '11_reversal_criteria')?.name}{tabs.find(tab => tab.tabLabel === '11_reversal_criteria')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '11_reversal_criteria')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '11_reversal_criteria' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '12_supported_countries')?.name}{tabs.find(tab => tab.tabLabel === '12_supported_countries')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '12_supported_countries')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '12_supported_countries' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '13_traffic_display')?.name}{tabs.find(tab => tab.tabLabel === '13_traffic_display')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '13_traffic_display')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '13_traffic_display' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '14_traffic_social')?.name}{tabs.find(tab => tab.tabLabel === '14_traffic_social')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '14_traffic_social')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '14_traffic_social' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '15_traffic_email')?.name}{tabs.find(tab => tab.tabLabel === '15_traffic_email')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '15_traffic_email')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '15_traffic_email' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '16_traffic_search')?.name}{tabs.find(tab => tab.tabLabel === '16_traffic_search')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '16_traffic_search')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '16_traffic_search' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '17_traffic_mobile')?.name}{tabs.find(tab => tab.tabLabel === '17_traffic_mobile')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '17_traffic_mobile')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '17_traffic_mobile' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '18_traffic_native')?.name}{tabs.find(tab => tab.tabLabel === '18_traffic_native')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '18_traffic_native')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '18_traffic_native' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '19_traffic_contextual')?.name}{tabs.find(tab => tab.tabLabel === '19_traffic_contextual')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '19_traffic_contextual')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '19_traffic_contextual' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '20_traffic_incentive')?.name}{tabs.find(tab => tab.tabLabel === '20_traffic_incentive')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '20_traffic_incentive')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '20_traffic_incentive' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '21_traffic_brand_bidding')?.name}{tabs.find(tab => tab.tabLabel === '21_traffic_brand_bidding')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Check
                                    type="checkbox"
                                    disabled
                                    checked={tabs.find(tab => tab.tabLabel === '21_traffic_brand_bidding')?.value === 'true'}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '21_traffic_brand_bidding' ? { ...t, value: e.target.checked ? 'true' : 'false' } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '22_other_restrictions')?.name}{tabs.find(tab => tab.tabLabel === '22_other_restrictions')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '22_other_restrictions')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '22_other_restrictions' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '23_changes_termination')?.name}{tabs.find(tab => tab.tabLabel === '23_changes_termination')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    value={tabs.find(tab => tab.tabLabel === '23_changes_termination')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '23_changes_termination' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '25_payment_terms')?.name}{tabs.find(tab => tab.tabLabel === '25_payment_terms')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '25_payment_terms')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '25_payment_terms' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '26_address')?.name}{tabs.find(tab => tab.tabLabel === '26_address')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '26_address')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '26_address' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '27_city')?.name}{tabs.find(tab => tab.tabLabel === '27_city')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '27_city')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '27_city' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '28_state')?.name}{tabs.find(tab => tab.tabLabel === '28_state')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '28_state')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '28_state' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '29_zipcode')?.name}{tabs.find(tab => tab.tabLabel === '29_zipcode')?.required && ' *'}</span>
                            <div className="w-75">
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={tabs.find(tab => tab.tabLabel === '29_zipcode')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '29_zipcode' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '30_execution_date')?.name}{tabs.find(tab => tab.tabLabel === '30_execution_date')?.required && ' *'}</span>
                            <div className="w-75">
                                <DatePicker
                                    placeholderText="Execution Date"
                                    disabled
                                    className="form-control form-control"
                                    selected={tabs.find(tab => tab.tabLabel === '30_execution_date')?.value ? moment(tabs.find(tab => tab.tabLabel === '30_execution_date').value, 'MM-DD-YYYY').toDate() : null}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '30_execution_date' ? { ...t, value: moment(e).format('MM-DD-YYYY') } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                />
                            </div>
                        </div>
                        {tabs.find(tab => tab.tabLabel === 'appendix_countries')?.value !== '' &&
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>{tabs.find(tab => tab.tabLabel === 'appendix_countries')?.name}{tabs.find(tab => tab.tabLabel === 'appendix_countries')?.required && ' *'}</span>
                                <div className="w-75">
                                    <textarea
                                        className="form-control"
                                        disabled
                                        rows={3}
                                        value={tabs.find(tab => tab.tabLabel === 'appendix_countries')?.value || ''}
                                        onChange={(e) => {
                                            const updatedTabs = tabs.map(t =>
                                                t.tabLabel === 'appendix_countries' ? { ...t, value: e.target.value } : t
                                            )
                                            setTabs(updatedTabs);
                                        }}>
                                    </textarea>
                                </div>
                            </div>
                        }
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>{tabs.find(tab => tab.tabLabel === '31_appendix')?.name}{tabs.find(tab => tab.tabLabel === '31_appendix')?.required && ' *'}</span>
                            <div className="w-75">
                                <textarea
                                    className="form-control"
                                    rows={10}
                                    value={tabs.find(tab => tab.tabLabel === '31_appendix')?.value || ''}
                                    onChange={(e) => {
                                        const updatedTabs = tabs.map(t =>
                                            t.tabLabel === '31_appendix' ? { ...t, value: e.target.value } : t
                                        )
                                        setTabs(updatedTabs);
                                    }}>
                                </textarea>
                            </div>
                        </div>
                        <hr />

                        <div className="d-flex justify-content-end mt-3">
                            {spinner ? <Button variant="primary" disabled><FontAwesomeIcon icon="spinner" spin /></Button> :
                                <Button variant="primary" onClick={submit}>Send Document</Button>
                            }
                        </div>
                    </>
                )
                :
                <Loading />
            }
        </>
    )
}
export default DocuSignInsertionOrderContent